import React from "react"
import styles from "./FormSectionTitle.module.scss"

const FormSectionTitle: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.label}>{children}</div>
}

export const FormSectionSubtitle: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.subtitle}>{children}</div>
}

export default FormSectionTitle
